const $ = require('jquery');
import run from '../../utilities/run';
import render from "../../utilities/render";
import {handleDisplayFor, resetDisplay, hide, combineElements} from "../../utilities/selectorHelpers";
import QuickWizard from "../../components/QuickWizard/QuickWizard";
import QuickBtnGroup from "../../components/QuickBtnGroup/QuickBtnGroup";
import typeAheadSource from "../../utilities/typeAheadSource";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {setSwitchery,instantiateSwitchery} from '../../utilities/instantiateSwitchery';
import EditChecker from '../../components/EditChecker/EditChecker';
import DetailsTab from './DetailsTab';
import PrimaryTab from './PrimaryTab';
import ShippingTab from './ShippingTab';
import BillingTab from './BillingTab';
import FscFacilitiesTab from './FscFacilitiesTab';
import ReviewTab from './ReviewTab';
import addressValidationFactory from '../common/AddressValidation.js';
import _ from "underscore";
import EscapeStringRegexp from "escape-string-regexp";
import {handleQueryParamTraversalToWizardTab} from '../../utilities/jumpToWizardLogic';
// Templates
const addressFormTemplate = require("./html/addressForm.html");
const phoneFormTemplate = require("./html/multiPhoneForm.html");
require("./splFacility.less");



// Live form from jsp
const targetSelector = "#retailer-wizard";
var isMerchant = false;
let isCSR = false;
let rltType;
let supplychainFacilities;
let shippingServices;
var enableUserEnteredAddressRadioForSPL =true;
var disableSubmitAddressBtnIfInvalidAddressForSPL = true;

run(targetSelector, ()=>{
  const el = $(targetSelector);
  isCSR = el.data("is-csr");
  rltType = el.data('rtl-type');
  supplychainFacilities = el.data('supplychain-facilities');
  shippingServices = el.data('shipping-services');
  if(el.data('rtl-type') ==="SPL"){
    isMerchant = true;
    enableUserEnteredAddressRadioForSPL=false;
    disableSubmitAddressBtnIfInvalidAddressForSPL=false;
  }
  createUpdate(el);
  setupEditChecker(el);
});

function getRenderedSCFacilities() { 
  const splFacilityHtml = require("./html/splFacility.html");
  const response = _.map(supplychainFacilities, (supplychainFacilityItem) => {
    return render(splFacilityHtml, {
      supplyChainFac: supplychainFacilityItem
    });
  });
 return response.join("");
}

function getShippingServices(){
  const shippingServicesHtml = require("./html/shippingServices.html");
  const response = _.map(shippingServices, (shippingServicesItem) => {
    return render(shippingServicesHtml, {
      shippingServ: shippingServicesItem
    });
  });
 return response.join("");
}

function getRenderRetailerFedExIdSec(){
  const RetailerFedExIdHtml = require("./html/retailerFedExIdHtml.html");
  const response = _.map(supplychainFacilities, (supplychainFacilityItem) => {
    if(supplychainFacilityItem.facId==1 || supplychainFacilityItem.facId==2){
    return render(RetailerFedExIdHtml, {
      supplyChainFac: supplychainFacilityItem
      
    });
  }
  });
 return response.join("");
}

function setupEditChecker(el){
  EditChecker.bindNavigation();
  EditChecker.bindChangeListener("#retailer-wizard");
  EditChecker.bindChangeListener("span.select2");
  $("#retailer-cancel-btn").data("edit-checker-redirect", el.data("cancel-redirect-url")); // cancel url set from jsp
  EditChecker.bindCancelButton("#retailer-cancel-btn");
}

function createUpdate(el){

  const validator = el.validate({
    errorPlacement: function(error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    }
    // Place all your validation rules here!!!
    // rules: {

    // }
  });

  validator.settings.ignore = ":disabled,:hidden";

  const sharedFormCreator = function(template, sectionTitle, hasSwitchery, canAllowFedexToCall,primaryphone,shippingphone,billingphone) {
    const init = render(
      template,
      {
        sectionTitle: sectionTitle,
        hasSwitchery: hasSwitchery,
        canAllowFedexToCall: canAllowFedexToCall,
        isMerchant:isMerchant,
        primaryphone: primaryphone,
        shippingphone: shippingphone,
        billingphone: billingphone,
      }
    )
   return init;
  };
  const reviewContentDisplay = function(hasPrimaryFields, contactType, sectionWrapper, targetTab, expandableTarget) {
    const init = render(
      require("./html/reviewContent.html"),
      {
        hasPrimaryFields: hasPrimaryFields,
        isCSR:isCSR,
        contactType: contactType,
        sectionWrapper: sectionWrapper,
        targetTab: targetTab,
        expandableTarget: expandableTarget,
        rltType:rltType
      }
    )
    return init;
  };

  let wizardHtml = $(render(
    require("./html/retailerWizardStub.html"),
    {
      hasMerchent:isMerchant,
      detailsTab: render(
        require("./html/detailsTab.html"),
        {
          //addressForm1: sharedFormCreator(addressFormTemplate, "Primary Account Address", false),
          // addressForm2: sharedFormCreator(addressFormTemplate, "Primary Contact Address", true, "Primary Contact Address shares Primary Account Address"),
          //multiPhoneForm1: sharedFormCreator(phoneFormTemplate, "Primary Contact Phone", false, true),
          // multiPhoneForm2: sharedFormCreator(phoneFormTemplate, "Primary Contact Form", true, "Primary Contact Phone shares Primary Account Phone"),
        }
      ),
      primaryInformationTab: render(
        require("./html/primaryInformationTab.html"),
        {
          hasMerchent:isMerchant,
          isCSR:isCSR,
          rltType:rltType,
          supplyChainFac :getRenderedSCFacilities(),
          shippingServ :getShippingServices(),
          addressForm1: sharedFormCreator(addressFormTemplate, "Primary Account Address", false, true,true,false,false),
          // addressForm2: sharedFormCreator(addressFormTemplate, "Primary Contact Address", true, "Primary Contact Address shares Primary Account Address"),
          multiPhoneForm1: sharedFormCreator(phoneFormTemplate, "Primary Contact Phone", false, true,true,false,false)
          // multiPhoneForm2: sharedFormCreator(phoneFormTemplate, "Primary Contact Form", true, "Primary Contact Phone shares Primary Account Phone"),
          //retailerFedExId : getRenderRetailerFedExIdSec()
        }
      ),
      shippingInformationTab: render(
        require("./html/shippingInformationTab.html"),
        {
          hasMerchent:isMerchant,
          shippingAccountAddressForm: sharedFormCreator(addressFormTemplate, "Shipping Account Information", true, false,false,true,false),
          // shippingAccountPhoneForm: sharedFormCreator(phoneFormTemplate, "Shipping Account Phone", false, false),
          // shippingContactAddressForm: sharedFormCreator(addressFormTemplate, "Shipping Contact Address", true, "Shipping Contact Address shares Shipping Account Address"),
          shippingContactPhoneForm: sharedFormCreator(phoneFormTemplate, "Shipping Contact Phone", false, false,false,true,false),
        }
      ),
      billingInformationTab: render(
        require("./html/billingInformationTab.html"),
        {
          hasMerchent:isMerchant,
          billingAccountAddressForm: sharedFormCreator(addressFormTemplate, "Billing Account Information", true, false,false,false,true),
          billingAccountPhoneForm: sharedFormCreator(phoneFormTemplate, "Billing Contact Phone", false, false,false,false,true),
          // billingContactAddressForm: sharedFormCreator(addressFormTemplate, "Billing Contact Address", true, "Billing Contact Address shares Billing Account Address"),
          // billingContactPhoneForm: sharedFormCreator(phoneFormTemplate, "Billing Contact Phone", true, "Billing Contact Phone shares Billing Account Phone"),
        }
      ),
      fscFacilitiesTab: render(
        require("./html/fscFacilitiesTab.html"),
        {

        }
      ),
      reviewTab: render(
        require("./html/reviewTab.html"),
        {
          primaryAccountInformation: reviewContentDisplay(true, "Primary", "primary-info-section", ".primary-information-tab"),
          shippingAccountInformation: reviewContentDisplay(false, "Shipping", "shipping-info-section", ".shipping-information-tab", "shipping-account-review"),
          billingAccountInformation: reviewContentDisplay(false, "Billing", "billing-info-section", ".billing-information-tab", "billing-account-review"),
        }
      ),
    }
  ));
  el.html(wizardHtml);

  const addressValidationModalEl = $("#add-validation-model");

  const quickWizard = new QuickWizard(el, {
    tabletWidthNavStep: 1048,
    mobileWidthNavStep: 886,
    shouldNavigateToForm: ({targetForm, direction, currentForm, done})=>{

      if(direction === "BACKWARDS"){
         return true;
      }
      if(currentForm.filter(".details-tab").length){
        const addressValidationForDetailsTab = addressValidationFactory(null, el, {
          isAlreadyValid: false,
          currentTab: ".details-tab",
          disableUserEnteredAddressRadio: enableUserEnteredAddressRadioForSPL,
          disableSubmitAddressBtnIfInvalidAddress: disableSubmitAddressBtnIfInvalidAddressForSPL
        });
        let addMerchantChecked = $('#addMerchantCheckbox')[0].checked;
        if (addMerchantChecked){
            if(!affiliatedMerchantHandler(el))
            return false;
        }
        areInputsValid(true, (validResult)=>{
          handleInputsFinishedValidatingForDestinationTab(false, validResult, done,addressValidationForDetailsTab);
      });
      }else if(currentForm.filter(".primary-information-tab").length){
        const addressValidationForPrimaryTab = addressValidationFactory(null, el, {
          isAlreadyValid: false,
          currentTab: ".primary-information-tab",
          disableUserEnteredAddressRadio: enableUserEnteredAddressRadioForSPL,
          disableSubmitAddressBtnIfInvalidAddress: disableSubmitAddressBtnIfInvalidAddressForSPL
        });
        if(el.data('rtl-type') ==="HONEYCOMB_RMS"){
          if(supplyChainFacilitiesChecked()){
            return false;
          }
          if(shippingServicesChecked()){
            return false;
          }
        }
        areInputsValid(true, (validResult)=>{
            handleInputsFinishedValidatingForDestinationTab(false, validResult, done,addressValidationForPrimaryTab);
        });

      } else if(currentForm.filter(".shipping-information-tab").length){
          const addressValidationForShippingTab = addressValidationFactory(null, el, {
          isAlreadyValid: false,
          currentTab: ".shipping-information-tab",
          disableUserEnteredAddressRadio: enableUserEnteredAddressRadioForSPL,
          disableSubmitAddressBtnIfInvalidAddress: disableSubmitAddressBtnIfInvalidAddressForSPL
        });
        
        areInputsValid(true, (validResult)=>{
            handleInputsFinishedValidatingForDestinationTab(shippingTab.isPrimarySwitchOn(), validResult, done,addressValidationForShippingTab);
        });
      } else  if(currentForm.filter(".billing-information-tab").length){
          const addressValidationForBillingTab = addressValidationFactory(null, el, {
          isAlreadyValid: false,
          currentTab: ".billing-information-tab",
          disableUserEnteredAddressRadio: enableUserEnteredAddressRadioForSPL,
          disableSubmitAddressBtnIfInvalidAddress: disableSubmitAddressBtnIfInvalidAddressForSPL
        });
        areInputsValid(true, (validResult)=>{
            handleInputsFinishedValidatingForDestinationTab(billingTab.isPrimarySwitchOn(), validResult, done,addressValidationForBillingTab);
        });
      } else  if(currentForm.filter(".fscFacilities-tab").length && targetForm.filter(".review-tab").length){
        const addressValidationForFacilitiesTab = addressValidationFactory(null, el, {
        isAlreadyValid: false,
        currentTab: ".fscFacilities-tab",
        disableUserEnteredAddressRadio: enableUserEnteredAddressRadioForSPL,
        disableSubmitAddressBtnIfInvalidAddress: disableSubmitAddressBtnIfInvalidAddressForSPL
      });
      areInputsValid(true, (validResult)=>{
          handleInputsFinishedValidatingForDestinationTab(false, validResult, done,addressValidationForFacilitiesTab);
      });
    }else {
        areInputsValid(true, done);
      }


      function areInputsValid(shouldContinue, cb) {
        let allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);
        let notValid = !quickWizard.areInputsValid(allPrevInputs, {displayErrors: true});
        if(notValid){
          quickWizard.goToFirstIncompleteForm();
          cb(false);
        } else {
          cb(true);
        }
      }


      function handleInputsFinishedValidatingForDestinationTab(primarySwitchOn, validResult, cb, tabAddressValidation) {
        if(validResult && !primarySwitchOn){
          tabAddressValidation.determineAddressValidity(cb);
        }
        else{
          cb(validResult);
        }
      }

      function affiliatedMerchantHandler(el){
        let merchantExists = false;

        const affMerchantName = $('.aff-merchant-name-val');
        if (affMerchantName != null && affMerchantName.length > 0 && affMerchantName[0].value != '')
          merchantExists = true;
        const affMerchantValue = el.find('.affMerchantNameValue');
        $.each(affMerchantValue, function() {
          if($(this).val() != null && $(this).val() != ''){
            merchantExists = true;
          }
        });
        if(!merchantExists ){
          el.find('#one-affiliated-message').show();
          return false;
        }else{
          el.find('#one-affiliated-message').hide();
          return true;
        }          
      }

      function supplyChainFacilitiesChecked(){
        let errorAalertMsg = $('body').find('.supply-chain-fac');
        if ($('.checkboxTest input:checkbox:checked').length > 0) {
          errorAalertMsg.hide();
          return false;
        } else {
          errorAalertMsg.show();
          return true;
        }
      }

      function shippingServicesChecked(){
        let errorAalertMsg = $('body').find('.shipping-serv');
        if ($('.checkboxTes input:checkbox:checked').length > 0) {
          errorAalertMsg.hide();
          return false;
        } else {
          errorAalertMsg.show();
          return true;
        }
      }
     return done;
      // going foward at this point

      // handle general validations on forward traversal - Comment out this part as below validation is taken care on address validation stuff.
     // let allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);

      //if(!quickWizard.areInputsValid(allPrevInputs, {displayErrors: true})){
       // quickWizard.goToFirstIncompleteForm();
        //return false;
      //} else {
        // check if each tab address validated, except for international address or if review tab.
      //}

    },
    didNavigateToForm: ({currentForm})=>{
      if(currentForm.filter(".review-tab").length){
        reviewTab.didNavigateToForm();
      }
      return true;
    }
  });

  quickWizard.init();

  $(document).on('click', "[data-target-form]", function(){
    const form = el.find($(this).data("target-form"));
    quickWizard.gotToForm(form);

  });

  const fedexCustomerButtonEl = el.find(".fedex-customer-toggler");
  const fedexCustomerButton = new QuickBtnGroup(fedexCustomerButtonEl, {distributeWidth: false});
  fedexCustomerButton.init();

  instantiateNameTypeAhead($('.account-search-typeahead'));

  function instantiateNameTypeAhead(el){
    const nameTypeAhead = el.typeahead({
      highlight: true
    },
    {
      name: 'retailerName',
      source: typeAheadSource(
        [
          "Jerry Thompson",
          "Alan Wrench",
          "Dennis Jones"
        ]
      )
    });
  }

  addMasks();
  addValidators();
  setWizardTitle();

  const detailsTab = new DetailsTab(quickWizard);
  detailsTab.init();

  const primaryTab = new PrimaryTab(quickWizard);
  primaryTab.init();

  const shippingTab = new ShippingTab(quickWizard);
  shippingTab.init();

  const billingTab = new BillingTab(quickWizard);
  billingTab.init();

  const fscFacilitiesTab = new FscFacilitiesTab(quickWizard)
  fscFacilitiesTab.init();

  const reviewTab = new ReviewTab(quickWizard);
  reviewTab.init();

  function addMasks(){
    $('.ret-mobile-area-code, .ret-office-area-code').inputmask({
      mask: "(999)"
    });

    $('.ret-mobile-phone').inputmask({
      mask: "999-9999"
    });
  }

  function setWizardTitle() {
    if(isMerchant){
      handleDisplayFor(el.find('.new-merchant-text'), true);
      handleDisplayFor(el.find('.new-retailer-text'), false);
      handleDisplayFor(el.find('.edit-retailer-text'), false);
      }else{
      handleDisplayFor(el.find('.new-merchant-text'), false);
      handleDisplayFor(el.find('.new-retailer-text'), !_.isObject(el.data('retailer-obj')));
      handleDisplayFor(el.find('.edit-retailer-text'), _.isObject(el.data('retailer-obj')));
      }
  }

  handleQueryParamTraversalToWizardTab(quickWizard);

  function addValidators() {
    $.validator.addClassRules("ret-phone-number-jqv", {validPhoneDigits: 7});
  }

  // phone number should haev minimum 7 digits
  $.validator.addMethod(
    "validPhoneDigits",
    function(value, element, params) {
      if(value.length == 0) 
        return true;
      let str = value.replace(/[_-]/g, ''); // replace the mask hyphen and underscore with blank as they are counted in length
      if(str.length < params) {
        return false;
      } else {
        return true;
      }
    },
    "Please enter {0} numeric values."
  );  

  $('input[type="checkbox"]').click(function () {
    errorAlertSupplyChain();
    errorAlertShippingService();
  });
  
  function errorAlertSupplyChain(){
    let errorAalertMsg = $('body').find('.error-alert-msg');
    if ($('.checkboxTest input:checkbox:checked').length > 0) {
      errorAalertMsg.hide();
    } else {
      errorAalertMsg.show();
    }
  }

  function errorAlertShippingService(){
    let errorAalertMsg = $('body').find('.error-alert-msgg');
    if ($('.checkboxTes input:checkbox:checked').length > 0) {
      errorAalertMsg.hide();
    } else {
      errorAalertMsg.show();
    }
  }

  errorAlertSupplyChain();
  errorAlertShippingService();

}



// WEBPACK FOOTER //
// ./src/pages/maintainRetailer/createUpdate.js